/* tslint:disable */
/* eslint-disable */
/**
 * Spring API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StanceResult } from './StanceResult';
import {
    StanceResultFromJSON,
    StanceResultFromJSONTyped,
    StanceResultToJSON,
    StanceResultToJSONTyped,
} from './StanceResult';

/**
 * 
 * @export
 * @interface NarrativeClassification
 */
export interface NarrativeClassification {
    /**
     * 
     * @type {number}
     * @memberof NarrativeClassification
     */
    narrativeId: number;
    /**
     * 
     * @type {StanceResult}
     * @memberof NarrativeClassification
     */
    stance: StanceResult;
}



/**
 * Check if a given object implements the NarrativeClassification interface.
 */
export function instanceOfNarrativeClassification(value: object): value is NarrativeClassification {
    if (!('narrativeId' in value) || value['narrativeId'] === undefined) return false;
    if (!('stance' in value) || value['stance'] === undefined) return false;
    return true;
}

export function NarrativeClassificationFromJSON(json: any): NarrativeClassification {
    return NarrativeClassificationFromJSONTyped(json, false);
}

export function NarrativeClassificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): NarrativeClassification {
    if (json == null) {
        return json;
    }
    return {
        
        'narrativeId': json['narrative_id'],
        'stance': StanceResultFromJSON(json['stance']),
    };
}

export function NarrativeClassificationToJSON(json: any): NarrativeClassification {
    return NarrativeClassificationToJSONTyped(json, false);
}

export function NarrativeClassificationToJSONTyped(value?: NarrativeClassification | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'narrative_id': value['narrativeId'],
        'stance': StanceResultToJSON(value['stance']),
    };
}

